import { Button, Container, Dialog, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import LoginSection from "../sections/LoginSection";
import { Context } from "../../App";

export default function InscriptionForm({event, setLoad}) {
    const { isConnected, setIsConnected } = React.useContext(Context);
    const [nom, setNom] = React.useState('');
    const [prenom, setPrenom] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [tel, setTel] = React.useState('');

    const [open, setOpen] = React.useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoad(true);
        fetch(`${process.env.REACT_APP_API_URL}/billet`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${isConnected ? localStorage.getItem('token') : localStorage.getItem('anonUserId') || ''}`
            }, body: JSON.stringify({ 
                owner: {//uuid du proprio
                    nom, prenom, email: mail, phone: tel
                }, //proprio du billet
                event: event._id, //id de l'événement
                price: event.montant
            })
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (response.status === 200) {
                const data = await response.json();
                //pop up de confirmation
                alert(`Billet ajouté au panier avec succès !`)
                window.location.href = `/`;
            } else {
                alert('Une erreur est survenue, veuillez réessayer plus tard.');
            }
            setLoad(false);
        }).catch(error => {
            console.error('Error:', error);
            alert('Une erreur est survenue, veuillez réessayer plus tard.');
            setLoad(false);
        });

    }

    useEffect(() => {
        if(isConnected&& !!localStorage.getItem('user')) {
            const user = JSON.parse(localStorage.getItem('user'));
            setNom(old=>!!old ? old : user.nom);
            setPrenom(old=>!!old ? old : user.prenom1);
            setMail(old=>!!old ? old : user.mail);
            setTel(old=>!!old ? old : user.tel);
        }
    }, [isConnected])

    return <Container component='form' onSubmit={handleSubmit} maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, minWidth: '400px' }}>
        <Typography variant="h4" align="center" sx={{ mb: 2 }}>Je m'inscris</Typography>

        <TextField fullWidth label="Nom" variant="outlined" value={nom} required
        onChange={(e) => setNom(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth label="Prénom" variant="outlined" value={prenom} required
        onChange={(e) => setPrenom(e.target.value)} sx={{ mb: 2 }} />

        <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required
        onChange={(e) => setMail(e.target.value)} sx={{ mb: 2 }} />

        <TextField fullWidth type="phone" label="GSM" variant="outlined" value={tel} 
        onChange={(e) => setTel(e.target.value)} sx={{ mb:4 }} />

        {!isConnected&&<Button variant="text" onClick={()=>setOpen(true)} sx={{alignSelf: 'end', px: 5, mb: 2}}>Je me connecte</Button>}

        <Button variant="contained" type="submit" sx={{alignSelf: 'center', my: 2}}>Ajouter au panier</Button>

        <Dialog open={open} onClose={() => setOpen(false)}><LoginSection {...{onLogin: ()=> {setOpen(false); setIsConnected(true)}}}/></Dialog>

    </Container>
}